import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FetchProjectAsinSkusListService(token,data) {
    return axios.post(`${CURRENT_API_URL}/contentmanagement/fetchProjectAsinSkusList`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        console.log(res.data)
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching data, please try again later.");
        return false;
    });
}

export default FetchProjectAsinSkusListService;